import { defineMessages } from 'react-intl';

export default defineMessages({
    documentTitle: {
        defaultMessage: 'Set New Password',
        description: 'Title of the invited sign up page',
        id: 'cv.invited.sign.up.document.title',
    },
    signUpToContinue: {
        defaultMessage: 'Sign up to continue',
        description: 'Complete sign up form sub title',
        id: 'cv.invited.sign.up.sub.title',
    },
});
